import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { FlexEducationTooltip } from './FlexEducationTooltip'
import { FlexPortionSummary } from './FlexPortionSummary'

type FlexPortionTileBadgeProps = {
  recipeCount: number
  portionCount: number
  onEdit: () => void
  showEducationTooltip?: boolean
  onCloseEducationTooltip?: () => void
}

export const FlexPortionTileBadge = ({
  recipeCount,
  portionCount,
  onEdit,
  showEducationTooltip = false,
  onCloseEducationTooltip,
}: FlexPortionTileBadgeProps) => {
  const badge = (
    <Box
      alignItems={AlignItems.Center}
      bg={Color.White}
      boxShadow="0 1px 5px 0 rgba(51, 61, 71, 0.2)"
      data-testid="flex-portion-tile-badge"
      display={Display.InlineFlex}
      maxWidth="100%"
      minHeight="44px"
      paddingH={3}
      position={DisplayPosition.Relative}
      style={{ borderRadius: '4px', overflow: 'visible', pointerEvents: 'auto' }}
    >
      <FlexPortionSummary
        recipeCount={recipeCount}
        portionCount={portionCount}
        onEdit={onEdit}
        stopEventPropagation
      />
    </Box>
  )

  if (!showEducationTooltip || !onCloseEducationTooltip) {
    return badge
  }

  return (
    <Box
      display={Display.Flex}
      justifyContent={JustifyContent.FlexEnd}
      position={DisplayPosition.Relative}
      width="100%"
      style={{ pointerEvents: 'none' }}
    >
      <FlexEducationTooltip onClose={onCloseEducationTooltip} />
      {badge}
    </Box>
  )
}
